import { CCard, CCardHeader } from "@coreui/react";
import React from "react";
const ExpensesReports = () => {
  return (
    <div className="content">
      <CCard className="mb-4">
        <CCardHeader>Expenses Reports</CCardHeader>
      </CCard>
    </div>
  );
};

export default ExpensesReports;
